// Extend the Window interface to include weeksWebCloudConfig
declare global {
  interface Window {
    weeksWebCloudConfig: {
      REACT_APP_SERVICE_URL: string;
      COUNTRIES_FOR_SHOWING_DISTANCE_IN_MILES?: string[];
      [key: string]: unknown;
    };
  }
}

// Import types for resort transformation
import { ApiResort, Resort } from '../interfaces';
// ADD: Missing imports for the seeAllAvailableWithFlag function
// import { SearchCriteriaElements } from '../slice/types';
// import { fetchResortDimensions } from '../slice/filterSlice';
// import { updateSearchCriteriaElements } from '../slice/searchSlice';
import { SearchStorageManager } from './searchStorageManager';
// FIXED: Import ThunkDispatch instead of regular Dispatch
// import { ThunkDispatch, AnyAction } from '@reduxjs/toolkit';
import { History } from 'history';
// import { AnyAction } from '@reduxjs/toolkit';
// import { RootState } from '../../../store/store.types'; // Import your root state type

/* istanbul ignore next -- defensive: window.weeksWebCloudConfig is always injected at runtime */
const { REACT_APP_SERVICE_URL, COUNTRIES_FOR_SHOWING_DISTANCE_IN_MILES } = window.weeksWebCloudConfig || {};

import { RESORT_ASSETS_PATH } from '../../../../src/common/constant/app.properties';

const {
  STATIC_ASSETS_DOMAIN,
  // STATIC_NO_IMAGE,
} = window.weeksWebCloudConfig;

// console.log('Resort Assets Path:', RESORT_ASSETS_PATH, STATIC_ASSETS_DOMAIN, STATIC_NO_IMAGE);

// thumbImage.imageName = `${STATIC_ASSETS_DOMAIN}${RESORT_ASSETS_PATH}${thumbImage.id}.jpg`;

/**
 * Get the API domain from window configuration
 * @returns The service URL for API calls
 */
export const getApiDomain = (): string => {
  // Use the service URL from window configuration, matching server-config.local.js
  return REACT_APP_SERVICE_URL;
};

/**
 * Get user data from localStorage
 * @returns User data object with memberId, language, and locale
 */
export const getUserData = () => {
  // Get user data from localStorage as used in header-comp.js
  const customerDetails = localStorage.getItem('_customerDetails');
  if (customerDetails) {
    try {
      const userData = JSON.parse(customerDetails);
      return {
        memberId: userData?.memberId || '',
        language: { code: userData.language?.code || 'en' },
        locale: userData.locale || 'en_US',
        currencies: userData.currencies || [],
        country: userData.country || 'US',
        typeaheadLanguageCode: userData.typeaheadLanguageCode || 'en'
      };
    } catch (error) {
      console.error('Error parsing customer details from localStorage:', error);
    }
  }
  
  // Fallback to default values
  return {
    memberId: '',
    language: { code: 'en' },
    locale: 'en_US'
  };
};

/**
 * Get user type (WEEKS or POINTS) from localStorage
 * @returns User type string
 */
export const getUserType = (): string => {
  // Get user type from localStorage similar to serviceCallRci.checkUserType()
  const customerDetails = localStorage.getItem('_customerDetails');
  if (customerDetails) {
    try {
      const userData = JSON.parse(customerDetails);
      // Check applicationType: 'WOW' = WEEKS, 'POW' = POINTS
      return userData.applicationType === 'WOW' ? 'WEEKS' : 'POINTS';
    } catch (error) {
      console.error('Error parsing user type from localStorage:', error);
    }
  }
  
  // Fallback to POINTS
  return 'POINTS';
};

// FIXED: Updated function with proper async thunk handling
export const seeAllAvailableWithFlag = async (
  // tempSearchCriteria: SearchCriteriaElements,
  // dispatch: ThunkDispatch<RootState, unknown, AnyAction>, // FIXED: Use ThunkDispatch
  history: History
) => {
  try {

    // // FIXED: Now .unwrap() will work properly
    // try {
    //   await dispatch(fetchResortDimensions(tempSearchCriteria)).unwrap();
    // } catch (fetchError) {
    //   console.warn('fetchResortDimensions failed, continuing anyway:', fetchError);
    // }
    
    // // Update search criteria elements
    // dispatch(updateSearchCriteriaElements(tempSearchCriteria));
    
    // Update localStorage
    
    // console.log('Deal Search Click - Updated Search Criteria with deal enabled:', tempSearchCriteria);
    
    // Navigate with timestamp to force re-render
    // history.replace(`/All/search?seeAllAvailable=true&isDeal=true`);
    window.location.href = `/pan-weeks-dashboard/All/search?seeAllAvailable=true&isDeal=true`;

    // Clear typeahead after navigation
    SearchStorageManager.removeItem('selectedSuggestion');
    SearchStorageManager.removeItem('selectedTypeAheadItemRefID');

  } catch (error) {
    console.error('Error activating deal search:', error);
    history.replace(`/pan-weeks-dashboard/All/search?seeAllAvailable=true`);
    SearchStorageManager.removeItem('selectedSuggestion');
    SearchStorageManager.removeItem('selectedTypeAheadItemRefID');
  }
}

/**
 * Get user locale in simplified format (e.g., 'en', 'fr', 'es')
 * @returns Simplified locale string
 */
export const getUserLocaleOnly = (): string => {
  const userData = getUserData();
  /* istanbul ignore else -- defensive: getUserData always returns a locale */
  if (userData && userData.locale) {
    const localeMap: { [key: string]: string } = {
      'en_US': 'en',
      'en_CA': 'en',
      'fr_FR': 'fr',
      'fr_CA': 'fr',
      'es_ES': 'es',
      'es_MX': 'es',
      'de_DE': 'de',
      'it_IT': 'it',
      'pt_BR': 'pt',
      'ja_JP': 'ja',
      'ko_KR': 'ko'
    };
    return localeMap[userData.locale] || 'en';
  }
  /* istanbul ignore next -- defensive: getUserData always returns a locale */
  return 'en';
};

export const getUserLocaleOnlyForMultiLang = (): string => {
  const userData = getUserData();
  // Chinese locale (zh_CN) uses 'sc' (Simplified Chinese) for typeahead
  if (userData?.locale === 'zh_CN') {
    return 'sc';
  }
  if (userData && userData.typeaheadLanguageCode) {
    return userData.typeaheadLanguageCode;
  }
  return 'en';
};

/**
 * Get appropriate icon for the given item type
 * @param type - The type of item (location, resort, favorite, etc.)
 * @returns Icon name string
 */
export const getIconForType = (type: string): string => {
  const icons: { [key: string]: string } = {
    location: 'location',
    region: 'location', 
    resort: 'building',
    favorite: 'heart',
    'saved-search': 'clock',
    'rci dictionary': 'location',
    city: 'location',
    geocode: 'location',
    other: 'location'
  };

  return icons[type] || 'location';
};

export const sanitizeSearchQuery = (query: string): string => {
  if (typeof query !== 'string') {
    return '';
  }
  return query.trim().replace(/'/g, "");
};

/**
 * Format date to YYYY-MM-DD string format
 * @param date - Date object to format
 * @returns Formatted date string in YYYY-MM-DD format
 */
export const formatDateYMD = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Format date to MM-DD-YYYY string format
 * @param date - Date object to format
 * @returns Formatted date string in MM-DD-YYYY format
 */
export const formatDateMDY = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

/**
 * Parse a date string in YYYY-MM-DD format as local timezone
 * This avoids the timezone shift issue that occurs when using new Date() with ISO strings
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object in local timezone
 */
export const parseDateAsLocal = (dateString: string): Date => {
  const parts = dateString.split('-').map(Number);
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  
  // Validate that we have all parts
  if (!year || !month || !day) {
    throw new Error(`Invalid date string: ${dateString}`);
  }
  
  // Month is 0-indexed in JavaScript Date
  return new Date(year, month - 1, day);
};

/**
 * Transform API Resort data to Resort format for UI consumption
 * @param apiResorts - Array of resort data from the API
 * @param translation - Optional translation object containing RESORT_COUNT message
 * @returns Array of transformed resort data for the UI
 */
export const transformResortData = (apiResorts: ApiResort[], translation?: { RESORT_COUNT?: string }): Resort[] => {
  return (apiResorts || []).map((resort) => {
    // Get primary address
    const primaryAddress = resort.contact.addresses.find(addr => addr.preferred) || resort.contact.addresses[0];

    // Format location string
    const location = primaryAddress 
      ? `${primaryAddress.city}, ${primaryAddress.state}`
      : 'Location not available';

    const imageArray: string[] = resort?.images.map((img) => {
      return `${STATIC_ASSETS_DOMAIN}${RESORT_ASSETS_PATH}/${img?.imageName}`;
    });

    // Format price
    const formatPrice = (minCost: number, maxCost: number): string => {
      if (minCost === 0 && maxCost === 0) {
        return 'Contact for pricing';
      }
      if (minCost === maxCost) {
        return `$${minCost.toFixed(2)}`;
      }
      return `Starting from $${minCost.toFixed(2)}`;
    };

    // Determine accommodation types based on product availability
    const accommodationTypes: string[] = [];
    if (resort.exAvailable) accommodationTypes.push('Exchange');
    if (resort.evAvailable) accommodationTypes.push('Extra Vacation');
    if (resort.lcAvailable) accommodationTypes.push('Last Call');

    // Pass through productType from API if available
    const productTypes: string[] = resort.productType || [];

    // Create basic amenities list (you can enhance this based on your needs)
    const amenities = ['Pool', 'WiFi']; // Default amenities, can be enhanced

    // Build the base resort object
    const baseResort = {
      ...resort,
      resourceKey: resort.id,
      name: resort.name,
      primaryImage: [...imageArray], // Placeholder image
      location: location,
      city: primaryAddress?.city || '',
      country: primaryAddress?.country || '',
      state: primaryAddress?.state || '',
      isDeal: resort.onSaleIndicator,
      availableSuites: resort.availableUnitCount,
      minPrice: formatPrice(resort.minCost, resort.maxCost),
      minCost: resort.minCost,
      accommodationTypes: accommodationTypes,
      productType: productTypes,
      amenities: amenities,
      description: `Experience luxury at ${resort.name}. This ${resort.stratum}-star rated resort offers exceptional amenities and service.`,
      checkInDate: resort.minCheckInDate,
      checkOutDate: resort.maxCheckInDate,
      isEnablewksFavoritedResort: resort.isEnablewksFavoritedResort,
      virtualAiResort: resort.virtualAiResort,
      virtualAiFlag: resort.virtualAiFlag,
      arnHotelId: String(resort.arnHotelId)
    };    // Conditionally add optional properties only if they have values
    const result: Resort = { ...baseResort };

    // Add minTp only if it's defined
    if (typeof resort.minTp === 'number') {
      result.minTp = resort.minTp;
    }

    // Add memberReviewInfo directly for TripAdvisor reviews
    /* istanbul ignore else -- defensive: memberReviewInfo is dereferenced unconditionally below, so it is always present */
    if (resort.memberReviewInfo) {
      result.memberReviewInfo = {
        reviewImageURL: resort.memberReviewInfo.reviewImageURL,
        numberOfReviews: resort.memberReviewInfo.numberOfReviews,
        averageNumberOfStars: resort.memberReviewInfo.averageNumberOfStars
      };
    }

    // Add tripAdvisorReviews only if we have review data
    if (resort.memberReviewInfo.numberOfReviews && resort.memberReviewInfo.numberOfReviews > 0) {
      result.tripAdvisorReviews = {
        count: resort.memberReviewInfo.numberOfReviews,
        rating: resort.memberReviewInfo.averageNumberOfStars || 0
      };
    }

    // Add urgency message only if conditions are met
    if (resort.availableUnitCount <= 5) {
      // Try to get translation from parameter first
      let resortCountMessage = translation?.RESORT_COUNT;
      
      if (!resortCountMessage) {
        // Use the reusable translation helper function
        resortCountMessage = getTranslatedMessageById(
          'PWE_WOW_Search',
          191,
          'Hurry, less than @@availableUnitCount units left!'
        );
      }
      if (resort.availableUnitCount === 1) {
        resortCountMessage = getTranslatedMessageById(
          'PWE_WOW_Search',
          192,
          'Hurry, @@availableUnitCount unit left!'
        );
      }

      
      // Replace placeholder with actual count
      result.urgencyMessage = resortCountMessage.replace('@@availableUnitCount', String(resort.availableUnitCount));
    }

    return result;
  });
};

/**
 * Generate default date range for search criteria
 * @returns Object with formatted start and end dates (today to 2 years from today)
 */
export const getDefaultDateRange = (): { minStartDate: string; maxStartDate: string } => {
  const today = new Date();
  const twoYearsFromToday = new Date();
  twoYearsFromToday.setFullYear(today.getFullYear() + 2);
  
  return {
    minStartDate: formatDateYMD(today),
    maxStartDate: formatDateYMD(twoYearsFromToday)
  };
};

/**
 * Retrieves the PWE_WOW_Search message object from localStorage.
 * This object contains translations and other UI messages for the search module.
 * @returns The PWE_WOW_Search object, or null if not found or on error.
 */
export const getSearchMessages = (): Record<string, unknown> | null => {
  try {
    const message = localStorage.getItem('message');
    if (!message) {
      return null;
    }

    return JSON.parse(message);
    // The structure is { "PWE_WOW_Search": { "key": "value" } }
    // return messageObject?.PWE_WOW_Search || null;
  } catch (error) {
    console.error('Error reading or parsing search messages from localStorage:', error);
    return null;
  }
};

/**
 * Get a translated message from localStorage by namespace and message ID
 * This avoids circular dependencies by not importing from utils/index.js
 * @param namespace - The message namespace (e.g., 'PWE_WOW_Search')
 * @param messageId - The message ID number
 * @param defaultMessage - The fallback message in English
 * @returns The translated message or the default message
 */
export const getTranslatedMessageById = (
  namespace: string,
  messageId: number,
  defaultMessage: string
): string => {
  try {
    const searchMessages = getSearchMessages();
    if (searchMessages && searchMessages[namespace]) {
      const messageGroup = searchMessages[namespace] as Record<string, unknown>;
      const messageData = messageGroup[String(messageId)];
      
      if (messageData && typeof messageData === 'object' && messageData !== null && 'translatedMessage' in messageData) {
        return (messageData as { translatedMessage: string }).translatedMessage;
      }
    }
  } catch (error) {
    /* istanbul ignore next -- defensive: getSearchMessages already guards parsing errors */
    console.error(`Error fetching translation for ${namespace}:${messageId}:`, error);
  }
  
  return defaultMessage;
};

export const extractIds = (idParam: string | null | undefined): string[] => {
  if (!idParam) return [];
  return idParam.split(/[,\s+]+/).map(id => id.trim()).filter(Boolean);
};

export function removeQueryParamFromUrl(paramName: string | string[]): URL {
   const urlObj = new URL(window.location.href);
   
   // Handle both single string and array of strings
   const paramsToRemove = Array.isArray(paramName) ? paramName : [paramName];
   
   // Remove each parameter
   paramsToRemove.forEach(param => {
     urlObj.searchParams.delete(param); // No effect if param doesn't exist
   });
   
   return urlObj;
}

export const getDistanceUnit = (memberCountryCode?: string): 'mi' | 'km' => {
  /* istanbul ignore next -- defensive: COUNTRIES list and each item are always defined via injected config */
  const countries = COUNTRIES_FOR_SHOWING_DISTANCE_IN_MILES?.map((item: string) => item?.replace(/\s+/g, '').toLowerCase()) || [];
  let distanceUnit: 'mi' | 'km' = 'km';
  if (memberCountryCode && countries.includes(memberCountryCode.replace(/\s+/g, '').toLowerCase())) {
    distanceUnit = 'mi';
  }
  return distanceUnit;
};

/**
 * Fires GTM events in a non-blocking manner using requestIdleCallback.
 * Each call cancels any previously pending callback so rapid successive calls
 * collapse into a single execution (last-write-wins deduplication).
 * @param callback GTM function to execute
 * @param timeout Max time to wait before forcing execution (default 2000ms)
 */
let _pendingGTMCallbackId: number | null = null;
let _pendingGTMTimeoutId: ReturnType<typeof setTimeout> | null = null;

export const fireGTMEventAsync = (
  callback: () => void,
  timeout: number = 2000
): void => {
  if ('requestIdleCallback' in window) {
    if (_pendingGTMCallbackId !== null) {
      window.cancelIdleCallback(_pendingGTMCallbackId);
      _pendingGTMCallbackId = null;
    }
    _pendingGTMCallbackId = window.requestIdleCallback(
      () => {
        _pendingGTMCallbackId = null;
        try {
          callback();
        } catch (error) {
          console.warn('GTM event failed (non-blocking):', error);
        }
      },
      { timeout }
    );
  } else {
    if (_pendingGTMTimeoutId !== null) {
      clearTimeout(_pendingGTMTimeoutId);
      _pendingGTMTimeoutId = null;
    }
    _pendingGTMTimeoutId = setTimeout(() => {
      _pendingGTMTimeoutId = null;
      try {
        callback();
      } catch (error) {
        console.warn('GTM event failed (non-blocking):', error);
      }
    }, 100);
  }
};

/**
 * Interface for fee availability check parameters
 */
export interface FeeAvailabilityCheckProps {
  combinedFeeValue: number;
  payRciTodayValue: number | null;
  resortFeeValue: number | null;
  payRciTodayText: string | null;
  resortFeeText: string | null;
}

/**
 * Check if price is unavailable based on fee values
 * Combines two conditions:
 * 1. Combined fee is zero or both payRciToday and resortFee are zero
 * 2. Extract numeric values from text and check if both are zero
 * @param props - Fee availability check parameters
 * @returns true if price should be marked as unavailable
 */
export const checkIfPriceUnavailable = (props: FeeAvailabilityCheckProps): boolean => {
  const { combinedFeeValue, payRciTodayValue, resortFeeValue, payRciTodayText, resortFeeText } = props;

  // Condition 1: Combined fee is zero or both payRciToday and resortFee are zero
  const isCombinedFeeZero = 
    combinedFeeValue === 0 || 
    (payRciTodayValue === 0 && resortFeeValue === 0);

  // Condition 2: Extract numeric values from text and check if zero
  const payRciTodayNumericValue = payRciTodayText ? Number(payRciTodayText.split(' ')[0]) : 0;
  const resortFeeNumericValue = resortFeeText ? Number(resortFeeText.split(' ')[0]) : 0;
  
  const isPayRciTodayZero = payRciTodayText !== null && payRciTodayNumericValue === 0;
  const isResortFeeZero = resortFeeText !== null && resortFeeNumericValue === 0;

  // Both conditions combined: if combined fee is zero OR both text prices are zero
  return isCombinedFeeZero || (isPayRciTodayZero && isResortFeeZero);
};
